var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.504 0a8.505 8.505 0 0 0 0 17.008A8.505 8.505 0 0 0 8.504 0ZM13.2 5.805l-5.916 5.916a.335.335 0 0 1-.259.11.335.335 0 0 1-.259-.11L3.808 8.763a.357.357 0 0 1 0-.518.357.357 0 0 1 .518 0l2.7 2.7 5.656-5.658a.357.357 0 0 1 .518 0 .357.357 0 0 1 0 .518Z",
    fill: "#3483DF"
  })));
};
export default SvgCheckmark;